var _linearGradient, _clipPath, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCsharp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 20,
    role: "img",
    "aria-label": "c#",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "c#") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 43,
    height: 20,
    fill: "#215e00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjOTlDQzAwIiByb2xlPSJpbWciIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+c2hhcnA8L3RpdGxlPjxwYXRoIGQ9Ik0xNC4yMjA5LjA4NzV2NS45NjEzbC0zLjc0MzMuNTAxMnYzLjUyMzNsMy43NDMzLS41MDEydjMuNTczNWwzLjQ5Mi0uNDY3MlY5LjEwNDdMMjQgOC4yNjM0bC0uNDYzMS0zLjQ2MTMtNS44MjQuNzc5NFYuMDg3NXpNNi4yODcgMS4xNDV2NS45NjE4TDAgNy45NDgzbC40NjM0IDMuNDYxMyA1Ljg1MTQtLjc4MzQgMy40NjQ0LS40NjM3VjEuMTQ1em0zLjUxOTggOS43MTg1bC0zLjQ5Mi40Njc1djMuNTc4bC02LjE4My44Mjc2LjQ2MzMgMy40NjEzIDUuODIzOS0uNzc5NnY1LjQ5NDJoMy40OTJ2LTUuOTYybDMuNjExNC0uNDgzNFYxMy45NDRsLTMuNzE1Ni40OTczem0xMy43MyAxLjc0MDVsLTUuODI0Ljc3OS0zLjQ5Mi40NjczdjkuMDE3OWgzLjQ5MnYtNS45NjE4TDI0IDE2LjA2NTJaIi8+PC9zdmc+"
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 305,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 150
  }, "c#"), /*#__PURE__*/React.createElement("text", {
    x: 305,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 150
  }, "c#"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsharp);
export default __webpack_public_path__ + "static/media/csharp.95bbb70c4909219c1367cfd83a713efd.svg";
export { ForwardRef as ReactComponent };